
export default function SocialProof() {
  const testimonials = [
    {
      name: 'Carolina Silva',
      location: 'São Paulo, Brasil',
      photo: 'https://public.readdy.ai/ai/img_res/49bb7bd376244d0c66a512d9bca2d784.jpg',
      rating: 5,
      quote: 'A PremierNY realizou o nosso sonho de conhecer Nova York! Cada detalhe foi planejado com perfeição. Nos sentimos seguros e bem‑vindos o tempo todo. O roteiro personalizado foi incrível!',
      trip: 'Viagem em Família 2024'
    },
    {
      name: 'Rafael & Juliana Costa',
      location: 'Rio de Janeiro, Brasil',
      photo: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20happy%20Brazilian%20couple%20in%20their%20twenties%20smiling%20together%2C%20casual%20elegant%20style%2C%20natural%20lighting%2C%20authentic%20travel%20photography%2C%20high%20quality%20headshot&width=200&height=200&seq=testimonial-002&orientation=squarish',
      rating: 5,
      quote: 'Nossa lua de mel foi absolutamente perfeita graças à PremierNY. A equipe sabia exatamente onde nos levar para as experiências mais românticas. Valeu cada centavo!',
      trip: 'Lua de Mel 2024'
    },
    {
      name: 'Marcos Oliveira',
      location: 'Belo Horizonte, Brasil',
      photo: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20confident%20Brazilian%20businessman%20in%20his%20forties%20with%20friendly%20smile%2C%20business%20casual%20attire%20natural%20lighting%20authentic%20travel%20photography%20high%20quality%20headshot&width=200&height=200&seq=testimonial-003&orientation=squarish',
      rating: 5,
      quote: 'Como era minha primeira vez em Nova York, estava nervoso com a barreira do idioma. O suporte da PremierNY facilitou tudo. Vi mais em 5 dias do que imaginava ser possível!',
      trip: 'Viagem Solo 2023'
    },
    {
      name: 'Fernanda & Lucas Martins',
      location: 'Brasília, Brasil',
      photo: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20happy%20young%20Brazilian%20couple%20with%20two%20children%2C%20family%20portrait%20style%20warm%20smiles%20casual%20clothing%20natural%20lighting%20authentic%20travel%20photography&width=200&height=200&seq=testimonial-004&orientation=squarish',
      rating: 5,
      quote: 'Viajar com crianças pode ser estressante, mas a PremierNY planejou tudo com perfeição. As crianças se divertiram muito, e nós também. Super recomendo!',
      trip: 'Viagem em Família 2023'
    },
    {
      name: 'Beatriz Santos',
      location: 'Curitiba, Brasil',
      photo: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20elegant%20Brazilian%20woman%20in%20her%20fifties%20with%20sophisticated%20style%20and%20warm%20smile%20natural%20lighting%20authentic%20travel%20photography%20high%20quality%20headshot&width=200&height=200&seq=testimonial-005&orientation=squarish',
      rating: 5,
      quote: 'O conhecimento privilegiado da PremierNY nos economizou muito tempo e dinheiro. Vivemos Nova York como moradores locais, não como turistas. O melhor investimento da nossa viagem!',
      trip: 'Viagem com Amigas 2024'
    },
    {
      name: 'André Rodrigues',
      location: 'Porto Alegre, Brasil',
      photo: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20young%20Brazilian%20man%20in%20his%20twenties%20with%20casual%20style%20and%20friendly%20expression%20natural%20lighting%20authentic%20travel%20photography%20high%20quality%20headshot&width=200&height=200&seq=testimonial-006&orientation=squarish',
      rating: 5,
      quote: 'Estava cético em contratar um guia, mas a PremierNY superou todas as expectativas. A equipe me mostrou lugares que eu jamais teria encontrado sozinho. Inesquecível!',
      trip: 'Viagem Solo 2024'
    }
  ];

  // Defensive rendering – if the data is empty or malformed we avoid breaking the UI
  if (!Array.isArray(testimonials) || testimonials.length === 0) {
    return (
      <section id="testimonials" className="bg-[#0a0a0a] py-24">
        <p className="text-center text-white">Nenhum depoimento disponível no momento.</p>
      </section>
    );
  }

  return (
    <section id="testimonials" className="bg-[#0a0a0a] py-24 relative overflow-hidden">
      {/* Decorative quotation mark */}
      <div className="absolute top-20 right-10 text-[#D4AF37]/5 text-[300px] font-serif leading-none pointer-events-none select-none">
        &quot;
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="mb-16">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold leading-tight text-white">
            Histórias reais de brasileiros viajantes
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/15 rounded-full flex-shrink-0">
                  <i className="ri-user-3-fill text-[#D4AF37] text-lg"></i>
                </div>
                <div>
                  <h4 className="text-black font-bold text-sm">{testimonial.name}</h4>
                  <p className="text-gray-600 text-xs flex items-center gap-1">
                    <span className="text-sm">🇧🇷</span>
                    {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D4AF37] text-base"></i>
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed mb-4 font-serif italic">
                {testimonial.quote}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
